import { isLocalhost } from '@xylabs/react-shared'
import { Log } from '@xylabs/sdk-js'

export const log = new Log({
  commitHash: process.env.REACT_APP_VERSION,
  devMode: isLocalhost(),
  rollbarToken: 'd4766b39c1cf47f49e8ea69d6b41d49f',
})
